import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ErrorLogout from "../../../helpers/ErrorLogout";
import { useTimer } from "react-timer-hook";
import { Button, Form, Image, Input, message, Modal } from "antd";
import { PiCurrencyInrBold } from "react-icons/pi";
import moment from "moment";
import ImageGallery from "./ImageGallery";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getSingleBid, rejectBid, scheduleBid } from "../../../api/CommonRequest";
import CalenderIcon from "../../../assets/icons/calender.svg";
import BiddersIcon from "../../../assets/icons/bidders.svg";
import PrevArrowIcon from "../../../assets/icons/prevArrow.svg";
import NextArrowIcon from "../../../assets/icons/nextarrow.svg";
import BidScheduleModal from "./BidScheduleModal";
import { SlCalender } from "react-icons/sl";
import { HiOutlineUsers } from "react-icons/hi";
import { MdOutlineTimer } from "react-icons/md";
import { FaIndianRupeeSign } from "react-icons/fa6";
import Timer from "./Timer";
import GoogleMapComponent from "../../googlemap/GoogleMapComponent";
import DocumentSection from "./DocumentSection";
const { TextArea } = Input;


function BidDetailedView({ bidID }) {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState();
  const [isExpanded, setIsExpanded] = useState(false);

  const [singleBid, setSingleBid] = useState(null);
  console.log(singleBid);

  const [loader, setLoader] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const formatPrice = (price) => {
    return (new Intl.NumberFormat("en-IN").format(
      price
    ))
  };
  useEffect(() => {
    setSelectedImage(singleBid?.productImage[0]?.url);
  }, [singleBid]);
  useEffect(() => {
    const bidCall = async () => {
      try {
        setLoader(true);
        // console.log(bidID, 'bidID');

        const { data } = await getSingleBid(bidID);
        // console.log(data, 'data');

        if (data?.success) {
          setLoader(false);
          setSingleBid(data?.singleBid);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    bidCall();
  }, [bidID]);

  const onFinish = (values) => {
    try {
      Modal.confirm({
        title: `Confirm Bid rejection`,
        content: `Are you sure you want to reject this bid? This action cannot be undone.`,
        onOk: async () => {
          try {
            const { data } = await rejectBid(singleBid._id, values);
            if (data?.update) {
              setSingleBid((prev) => ({
                ...prev,
                status: "rejected",
              }));
              setRejectModal(false);

              message.success("Bid rejected successfully");
            }
          } catch (error) {
            setRejectModal(false);
            message.error(error.message);
            console.log(error);
            console.log(error.message);
            if (error?.response?.status === 401) {
              ErrorLogout(error);
            }
          }
        },
        onCancel: () => {
          console.log("Cancel");
        },
      });
    } catch (error) {
      console.log(error);
      console.log(error.message);
      if (error?.response?.status === 401) {
        ErrorLogout(error);
      }
    }
  };



  const overview = [];
  const moreInfo = [];

  singleBid?.subCategoryDetails?.form.forEach(
    ({ name, type, icon, label, overview: isOverview }) => {
      let fieldValue;
      if (type === "date") {
        fieldValue = moment(singleBid?.detailedInfo[name]).format("YYYY");
      } else if (name === "description") {
        fieldValue = undefined;
      } else {
        fieldValue = singleBid?.detailedInfo[name];
      }

      if (fieldValue !== undefined) {
        const fieldObject = { value: fieldValue, icon, label };

        if (isOverview) {
          overview.push(fieldObject);
        } else {
          moreInfo.push(fieldObject);
        }
      }
    }
  );

  const handleCancel = () => {
    setRejectModal(false);
  };

  const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="absolute top-10 left-1/2 -translate-x-1/2 bg-white shadow-lg rounded-full p-1 cursor-pointer z-10 hover:shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        onClick={onClick}
      >
        <Image src={PrevArrowIcon}></Image>
      </div>
    );
  };

  const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="absolute bottom-10 left-1/2 -translate-x-1/2 bg-white shadow-lg rounded-full p-1 cursor-pointer z-10 hover:shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        onClick={onClick}
      >
        <Image src={NextArrowIcon}></Image>
      </div>
    );
  };
  const CustomPrevArrow1 = (props) => {
    const { onClick } = props;
    return (
      <div
        className="absolute top-1/2 left-[-10px] transform -translate-y-1/2 bg-[#081c6c] rounded-full p-2 cursor-pointer z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        onClick={onClick}
      >
        <Image src={PrevArrowIcon}></Image>
      </div>
    );
  };

  const CustomNextArrow1 = (props) => {
    const { onClick } = props;
    return (
      <div
        className="absolute top-1/2 right-[-10px] transform -translate-y-1/2 bg-[#081c6c] rounded-full p-2 cursor-pointer z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        onClick={onClick}
      >
        <Image src={NextArrowIcon}></Image>
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    horizontal: true,
    horizontalSwiping: true,
    arrows: singleBid?.productImage?.length > 5,
    prevArrow: singleBid?.productImage?.length > 5 ? <CustomPrevArrow /> : null,
    nextArrow: singleBid?.productImage?.length > 5 ? <CustomNextArrow /> : null,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          horizontal: true,
          horizontalSwiping: true,
          arrows: singleBid?.productImage?.length > 4,
          prevArrow:
            singleBid?.productImage?.length > 4 ? <CustomPrevArrow /> : null,
          nextArrow:
            singleBid?.productImage?.length > 4 ? <CustomNextArrow /> : null,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          horizontal: true,
          horizontalSwiping: true,
          arrows: singleBid?.productImage?.length > 3,
          prevArrow:
            singleBid?.productImage?.length > 3 ? <CustomPrevArrow1 /> : null,
          nextArrow:
            singleBid?.productImage?.length > 3 ? <CustomNextArrow1 /> : null,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          horizontal: true,
          horizontalSwiping: true,
          arrows: singleBid?.productImage?.length > 2,
          prevArrow:
            singleBid?.productImage?.length > 2 ? <CustomPrevArrow1 /> : null,
          nextArrow:
            singleBid?.productImage?.length > 2 ? <CustomNextArrow1 /> : null,
        },
      },
    ],
  };
  const [approveModal, setApproveModal] = useState(false);

  const handleScheduleBid = () => {
    setApproveModal(true)
  }
  const handleCancelScheduleBid = () => {
    setApproveModal(false)
  };

  const onSubmitScheduleBid = async (val) => {
    // console.log('valaues', val);
    setLoader(true);
    try {
      const { data } = await scheduleBid(singleBid._id, val)
      // console.log(data, 'data');
      if (data.update) {
        await message.success("Bid Approved Successfully");
        navigate("/bid-list");
      }

    } catch (error) {
      console.log(error);
      console.log(error.message);
      message.error(error.message);

      if (error?.response?.status === 401) {
        ErrorLogout(error); // Handle unauthorized access
      }
    } finally {
      setLoader(false); // Stop loading state
    }


  };

  const handleUserBids = () => {
    navigate("/view-bids", { state: { bidID: singleBid._id } });
  }

  if (loader) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <div className="px-4 pb-8 max-w-6xl">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-10">
          <div className="flex flex-col w-full lg:max-w-[480px] shrink-0">
            <div className="aspect-[4/3] w-full overflow-hidden rounded-xl bg-gray-100 shadow-md">
              <img
                src={selectedImage}
                alt="Selected"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="lg:w-84 md:w-84 w-full group mt-4">
              <Slider {...settings} className="h-full">
                {singleBid?.productImage?.map((image, index) => (
                  <div
                    key={index}
                    onClick={() => setSelectedImage(image?.url)}
                    className={`relative group cursor-pointer p-1 rounded-md border-2 transition-colors ${selectedImage === image?.url ? "border-[#1955EB]" : "border-transparent"
                      }`}
                  >
                    <img
                      src={image?.url}
                      alt={`Thumbnail ${index + 1}`}
                      className="w-full h-24 border-none shadow-md object-contain rounded-md"
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          {/* <div className="ml-2 min-w-[480px]">
            <div className="lg:flex justify-between items-center mb-6">
              <div>
                <h1 className="lg:text-[28px] font-medium  text-start">
                  {singleBid?.productName}
                </h1>
                <p className="text-[#313131] text-[16px] font-medium ">
                  Lot #{singleBid?._id}
                </p>
              </div>
            </div>
            <div className="flex gap-2">
              <div className=" items-center justify-between text-sm text-gray-700 my-3 ">
                <div className="flex items-center lg:gap-6 gap-2  mb-4 ml-3">
                  <div className="flex items-center gap-3">
                    {singleBid?.expectedPrice && (
                      <div className="flex items-center gap-3">
                        <span className="text-[#000000A6] lg:text-[16px] fint-normal">
                          Expected Price
                        </span>
                        <span className="font-semibold flex">
                          <PiCurrencyInrBold className="mt-1" />
                          {singleBid?.expectedPrice}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {singleBid?.bidStart && (
                  <>
                    <div className="flex items-center gap-3 mb-3">
                      <img alt="" src={CalenderIcon}></img>
                      <span className="text-[#000000A6] lg:text-[16px] font-normal">
                        Start Date
                      </span>
                      <span className="font-semibold">
                        {moment(singleBid?.bidStart).format("DD-MM-YYYY")}
                      </span>
                    </div>
                  </>
                )}
                {singleBid?.bidEnd && (
                  <div className="flex items-center gap-3">
                    <img alt="" src={CalenderIcon}></img>
                    <span className="text-[#000000A6] lg:text-[16px] fint-normal">
                      End Date
                    </span>
                    <span className="font-semibold">
                      {moment(singleBid?.bidEnd).format("DD-MM-YYYY")}
                    </span>
                  </div>
                )}
              </div>
              <div className=" items-center justify-between text-sm text-gray-700 my-3 ">
                <div className="flex items-center gap-3 mb-3 ml-2">
                  {singleBid?.initialPrice && (
                    <div className="flex items-center gap-3">
                      <span className="text-[#000000A6] lg:text-[16px] fint-normal">
                        Starting Bid
                      </span>
                      <span className="font-semibold flex">
                        <PiCurrencyInrBold className="mt-1" />
                        {singleBid?.initialPrice}
                      </span>
                    </div>
                  )}
                </div>

                <div className="lg:flex items-center justify-between text-sm text-gray-700 ">
                  <div className="flex items-center justify-between lg:gap-6 gap-2 lg:mt-0 md:mt-0 mt-3">
                    <div className="flex items-center gap-3">
                      <img src={BiddersIcon} alt="" className="p-3"></img>

                      <span className="text-[#000000A6] lg:text-[16px] fint-normal">
                        Current Bid
                      </span>
                      <span className="font-semibold">
                        {singleBid?.bidLivePrice}
                      </span>
                    </div>
                  </div>
                </div>

                <div className=" mt-3 pb-2 border-gray-200">
                  <div className="lg:flex items-center w-full text-sm text-gray-700 ">
                    <div className="flex items-center justify-between w-full lg:gap-6 gap-2 lg:mt-0 md:mt-0 mt-3">
                      <div className="flex items-center gap-3">
                        <img alt="" src={BiddersIcon} className="p-3"></img>

                        <span className="text-[#000000A6] lg:text-[16px] fint-normal">
                          No of bidders
                        </span>
                        <span className="font-semibold">23</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {singleBid?.bidStart && singleBid?.bidEnd && (
              <div className=" my-2 pb-2 border-gray-200 ">
                <div className="lg:flex items-center justify-between text-sm text-gray-700 ">
                  <div className="flex items-center gap-2">
                    <span className="font-normal text-[16px] text-black">
                      Time Remaining
                    </span>
                    <div className="flex items-center lg:gap-4 gap-2">
                      <div className="flex items-center justify-center w-10 h-10  border-[1px] rounded-[4px]">
                        <span className="font-semibold">{days}</span>
                        <span className="text-xs">d</span>
                      </div>
                      <span>:</span>
                      <div className="flex items-center justify-center w-10 h-10  border-[1px] rounded-[4px]">
                        <span className="font-semibold">{hours}</span>
                        <span className="text-xs">h</span>
                      </div>
                      <span>:</span>
                      <div className="flex items-center justify-center w-10 h-10  border-[1px] rounded-[4px] ">
                        <span className="font-semibold">{minutes}</span>
                        <span className="text-xs">m</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {singleBid?.status === "pending" && (
              <div>
                <div className="flex items-center space-x-4 mb-8">
                  <button
                    onClick={() => {
                      setRejectModal(true);
                    }}
                    className="lg:px-14 md:px-14 px-6 py-2 bg-white text-[16px] text-black border border-red-500 rounded-[4px] font-medium hover:bg-slate-100"
                  >
                    Reject
                  </button>
                  <button
                    onClick={() => {
                      navigate("/bid-approve", { state: singleBid._id });
                    }}
                    className="lg:px-14 md:px-14 px-6 py-2 bg-[#1955EB] text-[16px] text-white rounded-[4px] font-medium hover:bg-blue-700"
                  >
                    Edit & Approve
                  </button>
                </div>
              </div>
            )}
            {singleBid?.status === "approved" && (
              <div>
                <div className="flex items-center space-x-4 mb-8">

                  <button
                    onClick={() => {
                      handleScheduleBid()
                    }}
                    className="lg:px-14 md:px-14 px-6 py-2 bg-[#1955EB] text-[16px] text-white rounded-[4px] font-medium hover:bg-blue-700"
                  >
                    Schedule Bid
                  </button>
                </div>
              </div>
            )}
            {singleBid?.status === "live" && (
              <div>
                <div className="flex items-center space-x-4 mb-8">

                  <button
                    onClick={() => {
                      handleUserBids()
                    }}
                    className="lg:px-14 md:px-14 px-6 py-2 bg-[#1955EB] text-[16px] text-white rounded-[4px] font-medium hover:bg-blue-700"
                  >
                    View Bids
                  </button>
                </div>
              </div>
            )}
          </div> */}

          <div className="flex-1 min-w-0 w-full lg:max-w-[50%]">
            <div className="flex items-center justify-between mb-5">
              <h2 className="lg:text-[28px] md:text-[28px] text-[20px] font-medium text-[#000000D9]"> {singleBid?.productName}</h2>
            </div>
            <div className="flex flex-wrap items-center gap-3 mb-6">
              <span className="text-[13px] bg-[#F6F8FF] font-normal text-[#000000D9]"> Lot #{singleBid?._id}</span>
              <span className="text-[13px] bg-[#F6F8FF] text-[#1955EB] font-normal">{singleBid?.categoryDetails?.name}</span>
              <span className="text-[13px] bg-[#F6F8FF] text-[#1955EB] font-normal">{singleBid?.subCategoryDetails?.name}</span>
            </div>
            <div className="grid grid-cols-2 gap-6 mb-6 text-gray-700">
              {singleBid?.bidStart &&
                <div className="flex items-center gap-3">
                  <div className="bg-[#74B5FF0D] border-[#F6F8FF] rounded-full">
                    <SlCalender className="  p-3   w-11 h-11" />
                  </div>
                  <div>
                    <p className="text-[14px] font-normal text-[#0000008C]">   Start Date</p>
                    <p className="text-[16px] font-medium text-[#000000D9] pt-1"> {moment(singleBid?.bidStart).format("DD MMM YYYY")}</p>
                  </div>
                </div>
              }
              {singleBid?.bidEnd &&
                <div className="flex items-center gap-3">
                  <div className="bg-[#74B5FF0D] border-[#F6F8FF] rounded-full">
                    <SlCalender className="  p-3   w-11 h-11" />
                  </div>
                  <div>
                    <p className="text-[14px] font-normal text-[#0000008C]">   Ending Date</p>
                    <p className="text-[16px] font-medium text-[#000000D9] pt-1">  {moment(singleBid?.bidEnd).format("DD MMM YYYY")}</p>
                  </div>
                </div>
              }
              {singleBid?.bidCount ?
                (<div className="flex items-center gap-3">
                  <div className="bg-[#74B5FF0D] border-[#F6F8FF] rounded-full">
                    <HiOutlineUsers
                      className="  p-3   w-11 h-11" />
                  </div>
                  <div>
                    <p className="text-[14px] font-normal text-[#0000008C]">   No of Bids</p>
                    <p className="text-[16px] font-medium text-[#000000D9] pt-1">{singleBid?.bidCount}</p>
                  </div>
                </div>) : ""
              }

              {singleBid?.bidStart && singleBid?.bidEnd &&
                <Timer bidEnd={singleBid?.bidEnd} />
              }
              {singleBid?.initialPrice &&
                <div className="flex items-center gap-3">
                  <div className="bg-[#74B5FF0D] p-3 border-[#F6F8FF] rounded-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.0462 21.53C21.231 21.5299 21.4118 21.4762 21.5666 21.3755C21.7215 21.2747 21.8438 21.1311 21.9187 20.9622C21.9936 20.7933 22.0179 20.6063 21.9886 20.4238C21.9593 20.2414 21.8777 20.0714 21.7537 19.9344L14.503 11.9228L16.9132 9.74152C17.4065 9.295 17.7022 8.67084 17.7353 8.00632C17.7684 7.3418 17.5361 6.69135 17.0897 6.19805L14.4628 3.29556C14.2417 3.05128 13.9747 2.85294 13.6769 2.71186C13.3792 2.57078 13.0566 2.48972 12.7275 2.47332C12.3985 2.45693 12.0694 2.5055 11.7591 2.61628C11.4488 2.72706 11.1634 2.89787 10.9191 3.11895L4.68257 8.76339C4.1893 9.20994 3.89361 9.83413 3.86053 10.4987C3.82744 11.1632 4.05968 11.8137 4.50615 12.307L7.13303 15.2095C7.35352 15.4545 7.62041 15.6533 7.91824 15.7944C8.21607 15.9355 8.53893 16.0161 8.86813 16.0316C8.91066 16.0338 8.95318 16.0349 8.9957 16.0349C9.61727 16.0359 10.2167 15.8044 10.6763 15.386L13.087 13.2043L20.3379 21.2159C20.4274 21.315 20.5367 21.3941 20.6587 21.4482C20.7807 21.5023 20.9127 21.5302 21.0462 21.53ZM9.39476 13.9701C9.33726 14.0241 9.26927 14.0656 9.19503 14.0921C9.12078 14.1186 9.04188 14.1295 8.96323 14.1242C8.88461 14.1205 8.80749 14.1013 8.73636 14.0676C8.66522 14.034 8.60148 13.9865 8.54884 13.928L5.92199 11.0255C5.81545 10.9076 5.76005 10.7523 5.76795 10.5936C5.77585 10.4349 5.84641 10.2859 5.96414 10.1792L12.2007 4.53476C12.3185 4.42819 12.4739 4.37279 12.6326 4.38072C12.7913 4.38866 12.9403 4.4593 13.047 4.5771L15.6739 7.4796C15.7804 7.59742 15.8358 7.75272 15.8279 7.91137C15.82 8.07002 15.7494 8.21904 15.6317 8.3257L9.39476 13.9701Z" fill="black" fill-opacity="0.85" />
                      <path d="M2.9558 21.5302H15.3748C15.6281 21.5302 15.8709 21.4296 16.05 21.2506C16.229 21.0715 16.3296 20.8287 16.3296 20.5754C16.3296 20.3222 16.229 20.0793 16.05 19.9003C15.8709 19.7212 15.6281 19.6206 15.3748 19.6206H2.9558C2.70256 19.6206 2.4597 19.7212 2.28064 19.9003C2.10157 20.0793 2.00098 20.3222 2.00098 20.5754C2.00098 20.8287 2.10157 21.0715 2.28064 21.2506C2.4597 21.4296 2.70256 21.5302 2.9558 21.5302Z" fill="black" fill-opacity="0.85" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-[14px] font-normal text-[#0000008C]"> Starting Bid</p>
                    <p className="text-[16px] font-medium text-[#000000D9] pt-1">₹{formatPrice(singleBid?.initialPrice)}</p>
                  </div>
                </div>
              }
              {singleBid?.securityAmount &&
                <div className="flex items-center gap-3">
                  <div className="bg-[#74B5FF0D] border-[#F6F8FF] rounded-full">
                    <FaIndianRupeeSign
                      className="  p-3   w-11 h-11" />
                  </div>
                  <div>
                    <p className="text-[14px] font-normal text-[#0000008C]">   Security Amount</p>
                    <p className="text-[16px] font-medium text-[#000000D9] pt-1">₹{formatPrice(singleBid?.securityAmount)}</p>
                  </div>
                </div>
              }
              {singleBid?.expectedPrice &&
                <div className="flex items-center gap-3">
                  <div className="bg-[#74B5FF0D] border-[#F6F8FF] rounded-full">
                    <FaIndianRupeeSign
                      className="  p-3   w-11 h-11" />
                  </div>
                  <div>
                    <p className="text-[14px] font-normal text-[#0000008C]">   Expected Price</p>
                    <p className="text-[16px] font-medium text-[#000000D9] pt-1">₹{formatPrice(singleBid?.expectedPrice)}</p>
                  </div>
                </div>
              }
            </div>
            <div className="flex flex-wrap justify-between items-center gap-4 border-t border-[#003C98] mt-6 pt-6 ">
              {singleBid?.bidLivePrice &&
                <div>
                  <p className="font-normal flex text-[14px] text-[#000000D9] items-center">
                    Current Bid
                  </p>
                  <p className="font-medium text-[24px]  pt-1">₹{formatPrice(singleBid?.bidLivePrice)}</p>
                </div>
              }
              {/* <Tooltip title={user?._id === singleBid?.activeBidder ? "You are leading the auction at the moment." : ""}>
                <Button disabled={user?._id === singleBid?.activeBidder} onClick={isAuthenticated && userRefToken ? handleBidNow : handleLogin} className="w-fit h-12 px-11 bg-[#1955EB] text-white font-semibold rounded-[6px] text-[16px]">
                  PLACE BID
                </Button>
              </Tooltip> */}
              {singleBid?.status === "pending" && (
                <div>
                  <div className="flex items-center justify-start space-x-2">
                    <button
                      onClick={() => {
                        setRejectModal(true);
                      }}
                      className="lg:px-8 md:px-8 px-4 py-2  bg-white text-[14px] text-black border border-red-500 rounded-[4px] font-medium hover:bg-slate-100"
                    >
                      Reject
                    </button>
                    <button
                      onClick={() => {
                        navigate("/bid-approve", { state: singleBid._id });
                      }}
                      className="lg:px-8 md:px-8 px-4 py-2 bg-[#2549FF] text-[14px] text-white rounded-[4px] active:bg-[#003C98] font-medium hover:bg-[#0445C3]"
                    >
                      Edit & Approve
                    </button>
                  </div>
                </div>
              )}
              {singleBid?.status === "approved" && (
                <div>
                  <div className="flex items-center space-x-4 ">

                    <button
                      onClick={() => {
                        handleScheduleBid()
                      }}
                      className="lg:px-14 md:px-14 px-6 py-2 bg-[#1955EB] text-[16px] text-white rounded-[4px] font-medium hover:bg-blue-700"
                    >
                      Schedule Bid
                    </button>
                  </div>
                </div>
              )}
              {(singleBid?.status === "live" || singleBid?.status === "expired" || singleBid?.status === "closed" || singleBid?.status === "sell" || singleBid?.status === "sold") && (
                <div>
                  <div className="flex items-center space-x-4 ">

                    <button
                      onClick={() => {
                        handleUserBids()
                      }}
                      className="lg:px-10 md:px-14 px-6 py-2 bg-[#1955EB] text-[16px] text-white rounded-[4px] font-medium hover:bg-blue-700"
                    >
                      View Bids
                    </button>
                  </div>
                </div>
              )}

              <div>
                <div className="flex items-center space-x-4 ">

                  <button
                    onClick={() => {
                      navigate('/survey-single-view', { state: singleBid?.surveyID })
                    }}
                    className="lg:px-8 md:px-8 px-4 py-2 bg-[#2549FF] text-[14px] text-white rounded-[4px] active:bg-[#003C98] font-medium hover:bg-[#0445C3]"
                  >
                    Survey Details
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>


        <div className="border-b mt-7 pb-2 border-gray-200 "></div>
        {overview.length !== 0 && (
          <div className="mt-10">
            <div>
              <h2 className="text-[20px] font-bold text-[#000000D9] mb-4 text-start">
                Item Overview
              </h2>
              <div className="grid lg:grid-cols-4 gap-4">
                {overview.map((item, index) => {
                  const IconComponent = item.icon;
                  return (
                    <div
                      key={index}
                      className="flex flex-col items-center justify-center p-3 border border-gray-200 rounded-lg hover:border-blue-200 transition-colors"
                    >
                      <span className="font-semibold text-[#000000D9] text-[16px]">
                        {item.label}
                      </span>
                      {IconComponent}
                      <span className="text-[#000000A6] mt-2 text-[16px] font-normal">
                        {item.value}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
        <div className="mt-10">
          {moreInfo.length !== 0 && (
            <>
              <h2 className="text-[20px] font-bold text-[#000000D9] mb-4 text-start">
                Additional Details
              </h2>
              <div className="border border-gray-200 rounded-lg divide-y divide-gray-100">
                {moreInfo.map((item, index) => (
                  <div key={index} className="flex justify-between py-4 px-4 gap-4">
                    <div className="text-[#000000D9] text-[16px] text-start font-semibold min-w-0">
                      {item.label}
                    </div>
                    <div className="text-[#000000A6] font-normal text-start text-[16px] text-right">
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
          {singleBid?.detailedInfo?.description && (
            <div className="mt-10">
              <h2 className="text-[20px] font-bold text-[#000000D9] mb-4 text-start">
                Description
              </h2>

              <section
                className={`text-[#000000A6] text-[16px] leading-relaxed font-normal ${isExpanded ? "" : "line-clamp-3"
                  }`}
              >
                {singleBid?.detailedInfo?.description
                  ?.split("\n")
                  .map((line, index) => (
                    <p key={index} className="mb-2 text-start">
                      {line}
                    </p>
                  ))}
              </section>
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="text-[#1955EB] text-[16px] font-medium mt-2"
              >
                {isExpanded ? "See Less" : "See Full description"}{" "}
                <span className="inline-block transform transition-transform duration-200">
                  {isExpanded ? "▲" : "▼"}
                </span>
              </button>
            </div>
          )}
        </div>
        {singleBid?.documents ? (
          <div className="mt-10">
            <DocumentSection documents={singleBid?.documents} />
          </div>
        ) : null}

        {singleBid?.galleryImages && (
          <div className="mt-10">
            <ImageGallery images={singleBid?.galleryImages} />
          </div>
        )}

        {singleBid?.location && (
          <div className="mt-10">
            <GoogleMapComponent location={singleBid?.location} />
          </div>
        )}

        <div className="mt-10">
          <h2 className="text-[20px] font-bold text-[#000000D9]  mb-4">
            Terms & Conditions
          </h2>
          <div className="border-t border-b border-[#00000014] py-4">
            <p className="text-[#000000A6] text-[16px] font-normal leading-relaxed">
              Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa
              mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien
              fringilla, mattis ligula consectetur, ultricies mauris. Maecenas
              vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum
              auctor ornare leo, non suscipit magna interdum eu.
            </p>
            <p className="text-gray-700 text-sm leading-relaxed mt-4">
              Curabitur pellentesque nibh nibh, at maximus ante fermentum sit
              amet. Pellentesque commodo lacus at sodales sodales. Quisque
              sagittis orci ut diam condimentum, vel euismod erat placerat. In
              iaculis arcu eros, eget tempus orci facilisis id. Praesent lorem
              orci, mattis non efficitur id, ultricies vel nibh. Sed volutpat
              lacus vitae gravida viverra. Fusce vel tempor elit. Proin tempus,
              magna id scelerisque vestibulum, nulla ex pharetra sapien, tempor
              posuere massa neque nec elit.
            </p>
          </div>
        </div>
      </div>
      <Modal
        open={rejectModal}
        onCancel={handleCancel}
        footer={null}
        className=""
      // closeIcon={<AiOutlineCheckCircle className="text-green-600" />} // Close icon
      >
        <div className="p-4">
          <Form
            name="basic"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              label="Reject Reason"
              name="rejectNote"
              rules={[
                { required: true, message: "Please input reject reason!" },
              ]}
            >
              <TextArea rows={4} placeholder="Enter reject reason here..." />
            </Form.Item>
            <div className="flex justify-end mt-3">
              <Button
                onClick={handleCancel}
                className="py-3 px-6 mr-4   font-semibold"
              >
                Dismiss
              </Button>
              <Button
                htmlType="submit"
                className="bg-blue-500 py-3 px-6 text-white  font-medium"
              >
                Submit
              </Button>
            </div>
          </Form>
        </div>
      </Modal>

      <BidScheduleModal approveModal={approveModal} handleCancel={handleCancelScheduleBid} onFinishApproval={onSubmitScheduleBid} status={singleBid?.status} />
    </>
  );
}

export default BidDetailedView;
